import { Alert } from 'medialoopster/AlertMessage';

import { RootState } from '../../types/rootState';

export const getUserAlerts = (state: RootState): ReadonlyArray<Alert> => state.alerts.active;
export default {};
